module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.a7400a1.woff";